import React from "react";
import './style.scss';
import Logo from '../../assets/images/logo.png';
import CallIcon from '../../assets/images/call.png';
import { Link, Navigate, useNavigate } from "react-router-dom";

const Header = ({accessKey,hide, queryParams, dayPass}) =>{
  const navigate = useNavigate()
return(
    <header className="header-section">
    <div className="container">
      <div className="row">
        <div className="col-md-6 col-6 text-left">
        <img src={Logo} alt="Logo" className="header-logo"
              onClick={() => {
                if (!hide) {
                  if (dayPass && queryParams !== undefined) {
                    const queryParam = new URLSearchParams(window.location.search);
                    const utm_source = queryParam.get("utm_source");
                    const utm_medium = queryParam.get("utm_medium");
                    const utm_campaign = queryParam.get("utm_campaign");
                    let query = ''
                    if(utm_source || utm_medium || utm_campaign){
                      query = `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;
                    }
                    window.location.href = queryParams + query;
                  } else if (queryParams !== undefined) {
                    window.location.href = `/${accessKey}?${queryParams}`;
                  } else {
                    window.location.href = `/${accessKey}`;
                  }
                }
              }}
            />
        </div>
        <div className="col-md-6 col-6 text-right">
          <div className="call-icon-box">
            <img src={CallIcon} alt="Call" className="call-icon" />
            <a href="tel:1860 258 6633" className="call-text">1860 258 6633</a>
          </div>
        </div>
      </div>
    </div>
  </header>
)
}

export default Header;